export const VITALS_FORM_ERROR_BORDER = '2px solid #d32f2f';
export const VITALS_FORM_BORDER_TRANSITION = 'border 0.3s ease';
export const HISTORY_ELEMENT_SKELETON_TEXT = 'x'.repeat(55);
